import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

const TOKEN_KEY = "mgfx_token";

export function setToken(token) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    localStorage.removeItem(TOKEN_KEY);
    delete api.defaults.headers.common["Authorization"];
  }
}

const existing = localStorage.getItem(TOKEN_KEY);
if (existing) api.defaults.headers.common["Authorization"] = `Bearer ${existing}`;

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function trackEvent(name, params = {}) {
  try {
    if (window.dataLayer) window.dataLayer.push({ event: name, ...params });
    if (window.gtag) window.gtag("event", name, params);
  } catch (e) {}
}
